module.exports = __webpack_public_path__ + "media/images/smart_phone/menus/201809/top_images/3-aba4820b3c3f96e090501157c83a2319.png";